import { deleteValuationFile } from '../../../HttpRequests/valuations';

import handleException from '../../../Core/Helpers/handleException';
import fetchValuation from './fetchValuation';
import { getProps } from '../props';

export default () => async (dispatch) => {
    
  const { id } = getProps().match.params;

  try {
    
    await deleteValuationFile({ id });

    dispatch(fetchValuation());
    
  } catch(error) {

    handleException(error);

  }

}